import React from "react";
import * as Sentry from "@sentry/react";
import Layout from "../layouts/index";
import ConfirmEmail from "../screens/Account/ConfirmEmail";

const ConfirmEmailPage = () => {
  return (
    <Layout>
      <ConfirmEmail />
    </Layout>
  );
};

export default ConfirmEmailPage;
